module.exports = __webpack_public_path__ + "static/artist-development-the-process-mobile-2d8e39caec9c26d6506ecd4702b9c95f.png";